import { registerQuery } from 'data-fetching-client';
import httpClient from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getActiveHubTrialsByHubIdRpc, getAllHubTrialsByHubIdRpc } from 'trials-service-types';
const rpcClient = createRpcClientV2({
  hubHttpClient: httpClient
});
export const GET_ACTIVE_TRIALS = registerQuery({
  fieldName: 'activeTrials',
  fetcher() {
    return rpcClient.call(getActiveHubTrialsByHubIdRpc, {});
  }
});
export const GET_ALL_TRIALS = registerQuery({
  fieldName: 'allTrials',
  fetcher() {
    return rpcClient.call(getAllHubTrialsByHubIdRpc, {});
  }
});